import { Map } from 'immutable';

import baseReducer from 'redux/baseReducer';
import { createSymbols } from 'utils/helpers';

export const {
    EDIT_IN_UI,
    RESET_UI,
} = createSymbols([
    'EDIT_IN_UI',
    'RESET_UI',
]);

const initialState = Map({});

const editInUi = (state, { path, value }) => state.setIn(path, value);
const resetUi = (state, { keys = [] }) => {
    if (keys.length) {
        return state.filter((val, key) => {
            return keys.includes(key);
        });
    }

    return initialState;
};

export default baseReducer(initialState, {
    [EDIT_IN_UI]: editInUi,
    [RESET_UI]: resetUi,
});



// WEBPACK FOOTER //
// ./src/redux/ui/reducer.js